import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import "./admin.css";
import "./rolesset.css";
import { faAngleRight, faChevronLeft, faChevronRight, faMagnifyingGlass, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled, Switch } from '@mui/material';
import AdminRoletabs from '../../components/common/AdminRoletabs';
import { Link, useNavigate } from 'react-router-dom';
import { apiService } from '../../services/apiService';
import { toast } from 'react-toastify';
import { Modal } from 'react-bootstrap';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
const profileImage = require('../../assets/defaultprofile.svg').default;
function UserGroup() {
    const permissionstest = JSON.parse(localStorage.getItem('permissions'));
    const [groupdata, setGroupData] = useState([]);
    const navigate = useNavigate();
    const [paginatedata, setPaginateData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedRecord, setShowRecord] = useState(20);
    const [searchQuery, setSearchQuery] = useState("");
    const [loading, setLoading] = useState(false);
    const AntSwitch = styled(Switch)(({ theme }) => ({
        width: 40,
        height: 25,
        padding: 0,
        display: 'flex',
        '&:active': {
          '& .MuiSwitch-thumb': {
            width: 15,
          },
          '& .MuiSwitch-switchBase.Mui-checked': {
            transform: 'translateX(9px)',
          },
        },
        '& .MuiSwitch-switchBase': {
          padding: 2,
          '&.Mui-checked': {
            transform: 'translateX(15px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
              opacity: 1,
              backgroundColor: theme.palette.mode === 'dark' ? '#177ddc' : '#51cc64',
            },
          },
        },
        '& .MuiSwitch-thumb': {
          boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
          width: 20,
          height: 20,
          borderRadius: 100,
          transition: theme.transitions.create(['width'], {
            duration: 200,
          }),
        },
        '& .MuiSwitch-track': {
          borderRadius: 100,
          opacity: 1,
          backgroundColor:
            theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
          boxSizing: 'border-box',
        },
    }));

    const fetchTabData = useCallback(async (params = {}, per_page = selectedRecord) => {
        setLoading(true);
        try {
            const queryString = new URLSearchParams({
                ...params,
                per_page
            }).toString();
            const response = await apiService.getRequest(`admin/roles?${queryString}`);
            
            setGroupData(response.data);
            setPaginateData(response.meta);
        } catch (error) {
            console.error('Error fetching tab data:', error);
        }finally {
            setLoading(false);
        }
    }, [selectedRecord]);

    // Handle page change
    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        fetchTabData({ page: newPage });
    };

    // Handle search query change
    const handleSearch = () => {
        setCurrentPage(1);
        fetchTabData({ search: searchQuery });
    };

    // Fetch initial data on component mount
    useEffect(() => {
        fetchTabData();
    }, [fetchTabData]);

    const handleStatusToggle = async (groupId, currentStatus) => {
        const newStatus = currentStatus === 1 ? 0 : 1;
        
        // Optimistically update the UI before calling the API
        setGroupData(prevGroupData =>
          prevGroupData.map(group =>
            group.id === groupId ? { ...group, status: newStatus } : group
          )
        );
      
        try {
          const response = await apiService.patchRequest(`admin/roles/${groupId}/status`, {
            status: newStatus,
          });
          
          if (response.success) {
            toast(`Group status updated to ${newStatus === 1 ? 'Active' : 'Inactive'}`);
            fetchTabData({ search: searchQuery, page: currentPage });
          } else {
            // Revert back the status if the API call fails
            setGroupData(prevGroupData =>
              prevGroupData.map(group =>
                group.id === groupId ? { ...group, status: currentStatus } : group
              )
            );
            toast.error('Failed to update group status');
          }
        } catch (error) {
          console.error('Error updating group status:', error);
          setGroupData(prevGroupData =>
            prevGroupData.map(group =>
              group.id === groupId ? { ...group, status: currentStatus } : group
            )
          );
          toast.error('Failed to update group status');
        }
    };
    
    const [showAvatar, setShowAvatar] = useState(false);
    const [modalData2, setModalData2] = useState(null);
    
    const handleClose2 = () => setShowAvatar(false);
    
    const handleShow3 = (data) => {
        setModalData2(data);
        setShowAvatar(true);
    };

    const rows = groupdata && groupdata.map((datas) => ({
        id: datas.id,
        is_system: datas.is_system,
        userName: datas.name,
        userImage: datas.profile || profileImage,
        contactPhone: datas.phone_number,
        contactEmail: datas.email,
        status: datas.status,
        statusstring: datas.status_string,
        users: datas.users.map(user => ({
            display_name: user.name,
            memberImage: user.profile || profileImage,
            userId: user.id,
            userFormatid: user.formated_id,
            userType: user.user_type,
            isManager: user.is_group_manager,
        })),
    }));
    const columns = [
        {
            field: 'userName',
            headerName: 'Group Name',
             minWidth: 420,
            flex: 1,
            filterable: false,
            sortable: false,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    {permissionstest && permissionstest.manage_group_writer === true ? 
                        <Link to={`/user/group-edit/${params.row.id}`} className='cursetespoint' style={{color:"#C42B7D",textDecoration:"none"}} >{params.row.userName}</Link>:
                        <span style={{color:"#C42B7D"}}>{params.row.userName}</span>
                    }
                </div>
            ),
        },
        {
            field: 'Members',
            headerName: 'Members',
             minWidth: 320,
            flex: 1,
            filterable: false,
            sortable: false,
            renderCell: (params) => {
                const users = params.row.users || []; 
                return (
                    <Box display="flex" alignItems="center" height="100%" className="cursetespoint" onClick={() => handleShow3(users)}>
                        {Array.isArray(users) && users.length > 0 ? (
                            users.slice(0, 4).map((role,index) => (
                                <div key={index} style={{ marginRight: 10 }}>
                                    <img
                                        src={role.memberImage}
                                        alt={role.display_name}
                                        style={{
                                            width: 40, // Set width as needed
                                            height: 40, // Set height as needed
                                            borderRadius: '50%', // Make it circular
                                        }}
                                    />
                                </div>
                            ))
                        ) : (
                            <Typography color="textSecondary">No Members</Typography>
                        )}
                        {users.length > 4 && (
                            <Typography variant="body2" color="textSecondary" style={{ marginLeft: 5 }}>
                                +{users.length - 4} more
                            </Typography>
                        )}
                    </Box>
                );
            },
        },
        {
            field: 'status',
            headerName: 'Status',
            minWidth: 320,
            flex: 1,
            filterable: false,
            sortable: false,
            renderCell: (params) => (
                <Box className="h-100 d-flex align-items-center">
                    <small className='activestatus align-items-center gap-3 d-flex w-100'>
                        <AntSwitch
                        checked={params.row.status === 1}
                        onChange={() => handleStatusToggle(params.row.id, params.row.status)}
                        inputProps={{ 'aria-label': 'ant design' }}
                        />
                    <small style={{color:params.row.statusstring === 'Active' ? "#51cc64" : "red"}}>{params.row.statusstring}</small></small>
                </Box>
            )
        },
    ];
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{xs:12}} container className="main_jobseeker">
                <Grid size={{xs:12}} container alignItems="center">
                    <Grid size={{md:8,xs:12}} container flexDirection="column" className="jobseekerhead">
                        <h3>User</h3>
                        <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> User <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Group</span>
                    </Grid>
                    <Grid size={{md:4,xs:12}} container flexDirection="column">
                        <div className='d-flex jobseekersearch my-3'>
                            <div className='col-2'>
                                <FontAwesomeIcon className='iconcol' icon={faMagnifyingGlass} />
                            </div>
                            <div className='col-7'>
                                <input type='text' placeholder='search'
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            handleSearch(); // Trigger search on Enter key press
                                        }
                                    }}
                                />
                            </div>
                            <div className='col-3'>
                                <button onClick={handleSearch}>Search</button>
                            </div>
                        </div>
                    </Grid>
                    <Grid size={{md:12,xs:12}} container justifyContent="space-between" className="statusselectbtn my-4">
                        <Grid size={{sm:10,xs:12}} container>
                            <AdminRoletabs/>
                        </Grid>
                        <Grid container>
                            {permissionstest && permissionstest.manage_group_reader === true && permissionstest.manage_group_creator === true ? 
                                <button className="small_adsbtn" onClick={() =>{navigate("/user/group-add")}}>
                                    <FontAwesomeIcon icon={faPlus} />
                                </button>
                            :""}
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={{xs:12}} container>
                {loading ? 
                    <div className='d-flex justify-content-center w-100'>
                        <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                    </div> :
                    <Box sx={{ height: 650, width: '100%' }} className="datatable_jobpagi">
                    <DataGrid
                        style={{minHeight:"200px"}}
                        rows={rows}
                        columns={columns}
                        disableSelectionOnClick
                        components={{ Toolbar: GridToolbar }}
                    />
                    </Box>
                }
                </Grid>
                <Grid size={{xs:12}} container justifyContent="space-between" className="mt-3">
                    <div className='d-flex justify-content-end align-items-center'>
                        <label className='me-2'>Showing records <b>{paginatedata.from}</b>-<b>{paginatedata.to}</b> out of <b>{paginatedata.total}</b></label>
                    </div>
                    <div className='d-flex justify-content-end datatable_jobpagi align-items-center'>
                        <label className='me-2'>No. of Rows</label>
                        <select
                            label="Rows per page"
                            value={selectedRecord || 20}
                            onChange={(e) => {
                                const value = Number(e.target.value);
                                setShowRecord(value);
                                setCurrentPage(1);
                            }}
                            sx={{ mr: 2 }}
                        >
                            {[5, 10, 20, 50].map((size) => (
                                <option key={size} value={size}>{size}</option>
                            ))}
                        </select>
                    </div>
                </Grid>
                <Grid size={{xs:12}} container justifyContent="center" className="mt-4 pagination_btn">
                    <button className='arrowpaginate'
                        onClick={() => handlePageChange(currentPage - 1)} 
                        disabled={currentPage === 1}>
                        <FontAwesomeIcon icon={faChevronLeft} />
                    </button>
                    {paginatedata && paginatedata.last_page > 0 && (
                        <div className="pagination">
                            {(() => {
                            const totalPages = Math.max(1, paginatedata.last_page);
                            const pages = [];

                            const start = Math.max(2, currentPage - 2);
                            const end = Math.min(totalPages - 1, currentPage + 2);

                            // Always show page 1
                            pages.push(
                                <button
                                key={1}
                                onClick={() => handlePageChange(1)}
                                className={currentPage === 1 ? 'active' : ''}
                                >
                                1
                                </button>
                            );

                            // Ellipsis after page 1 if needed
                            if (start > 2) {
                                pages.push(<span key="start-ellipsis">...</span>);
                            }

                            // Middle pages
                            for (let i = start; i <= end; i++) {
                                pages.push(
                                <button
                                    key={i}
                                    onClick={() => handlePageChange(i)}
                                    className={currentPage === i ? 'active' : ''}
                                >
                                    {i}
                                </button>
                                );
                            }

                            // Ellipsis before last page if needed
                            if (end < totalPages - 1) {
                                pages.push(<span key="end-ellipsis">...</span>);
                            }

                            // Always show last page (if more than 1)
                            if (totalPages > 1) {
                                pages.push(
                                <button
                                    key={totalPages}
                                    onClick={() => handlePageChange(totalPages)}
                                    className={currentPage === totalPages ? 'active' : ''}
                                >
                                    {totalPages}
                                </button>
                                );
                            }

                            return pages;
                            })()}
                        </div>
                    )}
                    <button className='arrowpaginate'
                        onClick={() => handlePageChange(currentPage + 1)} 
                        disabled={currentPage === paginatedata.last_page}>
                        <FontAwesomeIcon icon={faChevronRight} />
                    </button>
                </Grid>
            </Grid>
            <Modal size='md' centered show={showAvatar} onHide={handleClose2}>
                <Modal.Header closeButton>
                    <h4>Members</h4>
                </Modal.Header>
                <Modal.Body className='mb-3 max_heightmebberscroll'>
                    <div className='d-flex flex-column justify-content-center'>
                        {/* <span className='ms-3'>{params.row.userName}</span> */}
                        {Array.isArray(modalData2) && modalData2.length > 0 ? (
                            modalData2.map((role,index) => (
                                <div key={index} style={{ marginBottom: 10 }} className='d-flex flex-wrap align-items-start'>
                                    <img
                                        src={role.memberImage}
                                        alt={role.display_name}
                                        style={{
                                            width: 40, // Set width as needed
                                            height: 40, // Set height as needed
                                            borderRadius: '50%', // Make it circular
                                        }}
                                    />
                                    <div className='flex_showers'>
                                        <span>{role.display_name}{role.isManager === true && <b className='manager_groupshow'>Manager</b>}</span>
                                        {role.userType === "sub_admin" ? <>
                                            {permissionstest && permissionstest.manage_subadmin_writer ? 
                                                <Link to={`/user/member-edit/${role.userId}`} target='_blank' className='cursetespoint' style={{color:"#C42B7D",textDecoration:"none"}} >{role.userFormatid}</Link>:
                                                <span style={{color:"#C42B7D"}}>{role.userFormatid}</span>
                                            }</>
                                            :<>
                                            {permissionstest && permissionstest.manage_jobseeker_writer ? 
                                                <Link to={`/user/jobseeker-details/${role.userId}`} target='_blank' className='cursetespoint' style={{color:"#C42B7D",textDecoration:"none"}} >{role.userFormatid}</Link>:
                                                <span style={{color:"#C42B7D"}}>{role.userFormatid}</span>
                                            }</>
                                        }
                                    </div>
                                </div>
                            ))
                        ) : (
                            <Typography color="textSecondary">No Members</Typography>
                        )}
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    </div>
  )
}

export default UserGroup
